import { SET_LEASE_COLUMNS, SET_SALE_COLUMNS } from '../actions/session';

export default function (state = {}, action) {
  switch (action.type) {
  case SET_LEASE_COLUMNS:
    return { ...state, currentLeaseColumns: action.columns };
  case SET_SALE_COLUMNS:
    return { ...state, currentSaleColumns: action.columns };
  default:
    return state;
  }
}
